import Vue from 'vue';

window.Vue = require('vue');

/**
 * Initializes vue and all its components
 */
export default function InitVueApp() {
	Vue.component('slider', require('../components/slider').default);

	const app = new Vue({
		el: 'body > .page-container'
	});
}
